import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { ProductGroupRepositoryBase } from '@skylab-shared/business';
export { ProductGroupRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(ProductGroupRepositoryBase)
export class ProductGroupRepository {
    public constructor(
        http: Http,
        weaver: Weaver
    ) {}
}
